import { Fragment, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getPolicy } from "../../store/about/aboutAction";
import Loader from "../../component/Loader";
import { Link } from "react-router-dom";
import Bread from "../../component/Bread";
const Policy = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { policy, loading } = useSelector((state) => state.aboutSlicer);
  
  // useEffect(() => {
  //    dispatch(getPolicy(lan));
  // }, [dispatch, lan]);

  return (
    <Fragment>
    <Bread title={"Home"} sub={"Policy"} />
    <section className="section-wrap faq">
      <div className="container">
        <div className="row">

          <div className="col-sm-8">
            <h2 className="uppercase mb-20">delivery questions</h2>
            <div className="toggle">
              <div className="acc-panel">
                <Link to={"/policy"}>how to track my delivery?</Link>
              </div>
              <div className="panel-content">
                <p>Amadea Theme is a very slick and clean e-commerce template with endless possibilities. Creating an awesome website. Amadea Theme is a very slick and clean e-commerce template with endless possibilities.
                </p>
              </div>
              <div className="acc-panel">
                <Link to={"/policy"}>where can I find tracking number?</Link>
              </div>
              <div className="panel-content">
                <p>We possess within us two minds. So far I have written only of the conscious mind. I would now like to introduce you to your second mind, the hidden and mysterious subconscious. Our subconscious mind contains such power.
                </p>
              </div>
              <div className="acc-panel">
                <Link to={"/policy"}>what delivery methods can I use? </Link>
              </div>
              <div className="panel-content">
                <p>We possess within us two minds. So far I have written only of the conscious mind. I would now like to introduce you to your second mind, the hidden and mysterious subconscious. Our subconscious mind contains such power.
                </p>
              </div>
            </div> 

            <h2 className="uppercase mb-20 mt-80">payment questions</h2>
            <div className="toggle mb-80">
              <div className="acc-panel">
                <Link to={"/policy"}>what payment methods do you accept?</Link>
              </div>
              <div className="panel-content">
                <p>Amadea Theme is a very slick and clean e-commerce template with endless possibilities. Creating an awesome website. Amadea Theme is a very slick and clean e-commerce template with endless possibilities.
                </p>
              </div>
              <div className="acc-panel">
                <Link to={"/policy"}>how to pay via credit card?</Link>
              </div>
              <div className="panel-content">
                <p>We possess within us two minds. So far I have written only of the conscious mind. I would now like to introduce you to your second mind, the hidden and mysterious subconscious. Our subconscious mind contains such power.
                </p>
              </div>
              <div className="acc-panel">
                <Link to={"/policy"}>what credit cards do you accept?</Link>
              </div>
              <div className="panel-content">
                <p>We possess within us two minds. So far I have written only of the conscious mind. I would now like to introduce you to your second mind, the hidden and mysterious subconscious. Our subconscious mind contains such power.
                </p>
              </div>
              <div className="acc-panel">
                <Link to={"/policy"}>how to pay via paypal?</Link>
              </div>
              <div className="panel-content">
                <p>We possess within us two minds. So far I have written only of the conscious mind. I would now like to introduce you to your second mind, the hidden and mysterious subconscious. Our subconscious mind contains such power.
                </p>
              </div>
            </div> 
          </div> 

          <div className="col-sm-3 col-sm-offset-1">
            <h2 className="uppercase mb-30">support</h2>
            <div className="service-item-box mb-30">
              <div className="icon-holder">
                <i className="fa fa-phone"></i>
              </div>
              <div className="service-text">
                <h3>phone</h3>
                <p>+1 (800) 2056 778</p>
              </div>
            </div>
            <div className="service-item-box mb-30">
              <div className="icon-holder">
                <i className="fa fa-envelope-o"></i>
              </div>
              <div className="service-text">
                <h3>email</h3>
                <p>ahasupport@gmail.com</p>
              </div>
            </div>
            <div className="service-item-box mb-40">
              <div className="icon-holder">
                <i className="fa fa-skype"></i>
              </div>
              <div className="service-text">
                <h3>skype</h3>
                <p>AhaSupport</p>
              </div>
            </div>
          </div> 

        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="call-to-action">
              <h5 className="uppercase">You want to get this theme now?</h5>
              <Link to={"/policy"} className="btn btn-lg btn-color"><span>Buy it now</span></Link>
            </div>
          </div>
        </div>

      </div>
    </section>
    </Fragment>
  );
};

export default Policy;
